module.exports = __webpack_public_path__ + "img/icon_model.dc357c97.svg";